export const CUSTOMER_TYPE_INDIVIDUAL = "INDIVIDUAL";
export const CUSTOMER_TYPE_COMPANY = "COMPANY";
